import React, { useState } from "react";
import { Helmet } from "react-helmet";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";

const Footer = ({ variant = "default", hipaaNote = false }) => {
  const [expanded, setExpanded] = useState(false);
  const year = new Date().getFullYear();

  const address =
    "ELTHIUM HEALTHCARE PVT LTD, MSR NORTH TOWER, 16TH FLOOR, DR. PUNEETH RAJ KUMAR ROAD, MS RAMAIAH NORTH CITY, MANAYATA, 560045 BENGALURU, KARNATAKA, INDIA";

  if (variant === "legacy") {
    return (
      <footer className="py-5 px-4 bg-primary-fixed text-on-primary-fixed-var">
      <Helmet>
        <title>Elthium Health - Healthcare Solutions & Medical Services</title>
        <meta
          name="description"
          content="Elthium Health by Elthium Health Pvt Ltd - One Platform, Total Wellness. Comprehensive healthcare solutions, medical services, and patient care."
        />
        <meta
          name="keywords"
          content="Elthium Health, healthcare solutions, medical services, patient care, health management, elthium health, bangalore hospitals, medical records"
        />
        <meta name="author" content="Elthium Health" />
        <link rel="canonical" href="https://credenthealth.com" />
        <meta property="og:title" content="Elthium Health - Healthcare Solutions & Medical Services" />
        <meta
          property="og:description"
          content="One Platform, Total Wellness - Comprehensive healthcare solutions and medical services by Elthium Health."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://credenthealth.com" />
        <meta property="og:image" content="https://credenthealth.com/logo.png" />
        <meta property="og:site_name" content="Elthium Health" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Elthium Health - Healthcare Solutions" />
        <meta name="twitter:description" content="One Platform, Total Wellness - Your trusted healthcare partner." />
        <meta name="twitter:image" content="https://credenthealth.com/logo.png" />
      </Helmet>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalOrganization",
            name: "Elthium Health",
            alternateName: "Elthium Health by Elthium Healthcare Pvt Ltd",
            url: "https://credenthealth.com",
            logo: "https://credenthealth.com/logo.png",
            description:
              "Elthium Health - One Platform, Total Wellness. Comprehensive healthcare solutions and medical services.",
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "MSR NORTH TOWER, 16TH FLOOR, DR. PUNEETH RAJ KUMAR ROAD, MS RAMAIAH NORTH CITY, MANAYATA",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560045",
              addressCountry: "IN",
            },
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+91-7619196856",
              email: "credenthealth@gmail.com",
              contactType: "customer service",
              areaServed: "IN",
              availableLanguage: ["English", "Hindi"],
            },
            sameAs: [
              "https://www.facebook.com/credenthealth",
              "https://www.twitter.com/credenthealth",
              "https://www.instagram.com/credenthealth",
              "https://www.linkedin.com/company/credenthealth",
            ],
          }),
        }}
      />

      <div className="container">
        <div className="row gy-4">
          <div className="col-12 col-lg-4">
            <h3 className="d-flex align-items-center mb-3 text-on-primary-fixed-var">
              <img
                src="/logo.png"
                alt="Elthium Health Logo - Healthcare Solutions"
                className="img-fluid me-2"
                style={{ width: "50px", height: "50px" }}
              />
              Elthium Health
            </h3>
            <p className="mb-3 text-on-primary-fixed-var">
              <strong>Elthium Healthcare Pvt Ltd.</strong> - Your trusted partner for comprehensive healthcare solutions.
              One Platform, Total Wellness - Offering medical services, health management, and patient care services.
            </p>
            <div className="d-flex gap-3 mt-3">
              <a href="https://www.facebook.com/credenthealth" target="_blank" rel="noopener noreferrer" className="text-on-primary-fixed-var" aria-label="Follow Elthium Health on Facebook">
                <FaFacebook size={20} />
              </a>
              <a href="https://www.twitter.com/credenthealth" target="_blank" rel="noopener noreferrer" className="text-on-primary-fixed-var" aria-label="Follow Elthium Health on Twitter">
                <FaTwitter size={20} />
              </a>
              <a href="https://www.instagram.com/credenthealth" target="_blank" rel="noopener noreferrer" className="text-on-primary-fixed-var" aria-label="Follow Elthium Health on Instagram">
                <FaInstagram size={20} />
              </a>
              <a href="https://www.linkedin.com/company/credenthealth" target="_blank" rel="noopener noreferrer" className="text-on-primary-fixed-var" aria-label="Follow Elthium Health on LinkedIn">
                <FaLinkedin size={20} />
              </a>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-2">
            <h5 className="mb-3 mt-3 font-bold text-on-primary-fixed-var">Explore</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><a href="/home" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-on-primary-fixed-var" title="Elthium Health Home">Home</a></li>
              <li className="mb-2"><a href="/profile" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-on-primary-fixed-var" title="Elthium Health Profile">Profile</a></li>
              <li className="mb-2"><a href="/medicalrecord" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-on-primary-fixed-var" title="Elthium Health Medical Records">Medical Records</a></li>
              <li className="mb-2"><a href="/family" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-on-primary-fixed-var" title="Elthium Health Family Members">Family Members</a></li>
            </ul>
          </div>

          <div className="col-6 col-md-4 col-lg-3">
            <h5 className="mb-3 mt-3 font-bold text-on-primary-fixed-var">Wellness Services</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><a href="/mybookings" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-on-primary-fixed-var" title="Elthium Health Bookings">My Bookings</a></li>
              <li className="mb-2"><a href="/mybookings" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-on-primary-fixed-var" title="Elthium Health Cart">My Orders</a></li>
              <li className="mb-2"><a href="/wallet" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-on-primary-fixed-var" title="Elthium Health Wallet">Wallet</a></li>
              <li className="mb-2"><a href="/chat" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-on-primary-fixed-var" title="Elthium Health Chat">Chat</a></li>
              <li className="mb-2"><a href="/help" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-on-primary-fixed-var" title="Elthium Health Help">Help & Support</a></li>
            </ul>
          </div>

          <div className="col-12 col-md-4 col-lg-3">
            <h5 className="mb-3 mt-3 font-bold text-on-primary-fixed-var">Get in touch</h5>
            <ul className="list-unstyled">
              <li className="d-flex align-items-start mb-2 text-on-primary-fixed-var">
                <FaMapMarkerAlt className="me-2 mt-1 flex-shrink-0" />
                <div>
                  <span>{expanded ? address : `${address.substring(0, 85)}...`}</span>
                  <button
                    onClick={() => setExpanded(!expanded)}
                    className="border-0 bg-transparent text-primary fw-semibold ms-2 p-0"
                  >
                    {expanded ? "View Less" : "View More"}
                  </button>
                </div>
              </li>
              <li className="d-flex align-items-center mb-2">
                <FaPhone className="me-2 flex-shrink-0" />
                <a href="tel:+917619196856" className="text-decoration-none text-on-primary-fixed-var">+91 7619196856</a>
              </li>
              <li className="d-flex align-items-center">
                <FaEnvelope className="me-2 flex-shrink-0" />
                <a href="mailto:credenthealth@gmail.com" className="text-decoration-none text-on-primary-fixed-var">credenthealth@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="mt-5 mb-4 border-surface-variant" />

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <p className="mb-2 mb-md-0 text-center text-md-start text-on-primary-fixed-var">
            &copy; {year} <strong>Elthium Health</strong> - Preventive Healthcare Solutions & Medical Services.
          </p>
          <div className="d-flex gap-3 mt-2 mt-md-0">
            <a href="/privacyandpolicy" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-on-primary-fixed-var" title="Elthium Health Privacy Policy">Privacy Policy</a>
            <a href="/termsandconditions" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-on-primary-fixed-var" title="Elthium Health Terms & Conditions">Terms & Conditions</a>
          </div>
        </div>
      </div>
    </footer>
    );
  }

  // default (+ minimal/hra aliases): single-row footer
  return (
    <footer className="border-t border-surface-container bg-background py-4 px-4 pb-16 lg:py-6 lg:pb-6 sm:px-6 mt-auto shrink-0">
      <div className="max-w-7xl mx-auto flex flex-col gap-6 lg:grid lg:grid-cols-12 lg:gap-6 lg:items-center text-sm">
        <span className="font-bold text-primary text-lg sm:text-xl text-center lg:col-span-3 lg:text-left">
          Elthium Health
        </span>
        <nav className="grid grid-cols-2 gap-x-4 gap-y-3 sm:flex sm:flex-wrap lg:col-span-6 sm:justify-center sm:gap-x-5 sm:gap-y-2 text-on-surface-variant">
          <a href="/privacyandpolicy" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">Privacy Policy</a>
          <a href="/termsandconditions" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">Terms of Service</a>
          {/* <a href="/privacyandpolicy" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">HIPAA Compliance</a> */}
          <a href="/help" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">Contact Support</a>
        </nav>
        <p className="lg:col-span-3 text-on-surface-variant text-center lg:text-right text-xs sm:text-sm">
          © {year} Elthium Health. All rights reserved.{hipaaNote ? " HIPAA Compliant Portal." : ""}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
